module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/title-result@3x-b737e923007232833669e39cd433f2cd.png";